import { IToken } from "./login.services";
import { StorageKeys } from "./constants";
import { currentEnv, currentVer } from "../helpers/utils";
import { ISubscriptionData } from "./dashboard.services";

export interface IAppLocalStorage {
  userToken: IToken | null;
  subData: ISubscriptionData[] | null;
  selectedSubData: ISubscriptionData | null;
  parentClientID: string | null;
  env: string;
  version: string | null;
}

export const appServices = {
  initialize,
};

/**
 * Loads information from the localStorage
 *
 * @returns {IAppLocalStorage} Returns the storaged token or false if there is not any
 */

async function initialize(): Promise<IAppLocalStorage> {
  const _userToken = localStorage.getItem(StorageKeys.USER);
  const _subData = localStorage.getItem(StorageKeys.SUBSCRIPTION_DATA);
  const _selectedSubData = localStorage.getItem(
    StorageKeys.SELECTED_SUBSCRIPTION
  );

  const userToken =
    _userToken !== null ? (JSON.parse(_userToken) as IToken) : _userToken;
  const subData =
    _subData !== null
      ? (JSON.parse(_subData) as ISubscriptionData[])
      : _subData;
  const selectedSubData =
    _selectedSubData !== null
      ? (JSON.parse(_selectedSubData) as ISubscriptionData)
      : _selectedSubData;

  const parentClientID = localStorage.getItem(StorageKeys.PARENT_CLIENT_ID);
  const env = currentEnv();
  const version = currentVer();

  return {
    userToken,
    subData,
    selectedSubData,
    parentClientID,
    env,
    version,
  };
}
